// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__CbFPC","title":"Header_title__1mkgL","left":"Header_left__3iCGw","clinicName":"Header_clinicName__qB8oY"};